module.exports = __webpack_public_path__ + "img/logo-app-white.5a616199.svg";